import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { addAppMiddleware } from "@/store/utils";

import { IpifyIP } from "./ipify.types";

export const ipifyApi = createApi({
  reducerPath: "ipify",
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 60 * 10, // 10 minutes
  baseQuery: fetchBaseQuery({
    baseUrl: "https://api.ipify.org/"
  }),
  tagTypes: ["IP"],
  endpoints: (builder) => ({
    getIp: builder.query<IpifyIP, void>({
      query: () => ({
        url: "/",
        method: "GET",
        params: {
          format: "json"
        }
      }),
      providesTags: ["IP"]
    })
  })
});
addAppMiddleware(ipifyApi.middleware);
